import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "settings-seg"
}
const _hoisted_3 = { class: "seg seg-dark" }
const _hoisted_4 = { class: "form-wrapper settings-form" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "settings-card" }
const _hoisted_7 = { style: {"margin-bottom":"25px"} }
const _hoisted_8 = ["src"]
const _hoisted_9 = { style: {"margin-bottom":"25px"} }
const _hoisted_10 = { style: {"padding":"30px","background":"var(--dark-gray)","margin-bottom":"20px","display":"flex","justify-content":"center"} }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "settings-card" }
const _hoisted_13 = { class: "settings-card" }
const _hoisted_14 = { class: "settings-card" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "settings-card" }
const _hoisted_17 = { class: "settings-card" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "form-close" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = {
  key: 0,
  class: "edit-form-field"
}
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = { class: "form-close" }
const _hoisted_26 = ["onSubmit"]
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = {
  class: "checkbox-input",
  style: {"margin-top":"10px"}
}
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = {
  key: 1,
  class: "checkbox-input",
  style: {"margin-top":"10px"}
}
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = {
  class: "checkbox-input",
  style: {"margin-top":"10px"}
}
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = {
  key: 2,
  class: "checkbox-input",
  style: {"margin-top":"10px"}
}
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = { key: 3 }
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = { style: {"display":"flex"} }
const _hoisted_39 = { class: "settings-card" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "form-close" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = {
  key: 0,
  class: "edit-form-field"
}
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = { class: "form-close" }
const _hoisted_48 = ["onSubmit"]
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = { style: {"display":"flex"} }
const _hoisted_51 = { class: "btn-row settings-save" }
const _hoisted_52 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drop_file = _resolveComponent("drop-file")!
  const _component_chip_list_editor = _resolveComponent("chip-list-editor")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_settings_layout = _resolveComponent("settings-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "page-bar" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Settings"),
        _createElementVNode("div", { class: "page-bar-main" }, "Configuration")
      ])
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      _createVNode(_component_settings_layout, {
        desc: _ctx.type == 'teamhub' ? 'Employee teams and the fields kept on employee records and reviews.' : 'Company identity and the lists used across your Ironbook.'
      }, {
        default: _withCtx(() => [
          (_ctx.$store.state.user.teamHubRole == 'Admin' && _ctx.$store.state.user.role == 'Admin')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = () => { _ctx.type = 'playbook' }),
                    class: _normalizeClass(_ctx.type == 'playbook' ? 'on' : '')
                  }, "Content", 2),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = () => { _ctx.type = 'teamhub' }),
                    class: _normalizeClass(_ctx.type == 'teamhub' ? 'on' : '')
                  }, "Team Hub", 2)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.type == 'playbook')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("section", _hoisted_6, [
                    _createElementVNode("div", null, [
                      _cache[13] || (_cache[13] = _createElementVNode("h3", null, "Company Name", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.Name) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.formData.Name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _cache[14] || (_cache[14] = _createElementVNode("h3", null, "Dark Logo", -1)),
                      (_ctx.formData.LogoPath)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            style: {"max-height":"45px","margin-bottom":"12px"},
                            src: _ctx.$store.state.spacesUrlPublic + _ctx.formData.LogoPath
                          }, null, 8, _hoisted_8))
                        : _createCommentVNode("", true),
                      _createVNode(_component_drop_file, { onFileChange: _ctx.onLogoChange }, null, 8, ["onFileChange"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[15] || (_cache[15] = _createElementVNode("h3", null, "Light Logo", -1)),
                      _cache[16] || (_cache[16] = _createElementVNode("div", {
                        class: "chip-editor-hint",
                        style: {"margin-bottom":"12px"}
                      }, "This logo will be used in the header of your Ironbook and in your emails. It will be presented over a dark gray background. Use a white or light colored logo with transparency.", -1)),
                      _createElementVNode("div", _hoisted_10, [
                        (_ctx.formData.LightLogoPath)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              style: {"height":"45px","margin":"0 0 10px"},
                              src: _ctx.$store.state.spacesUrlPublic + _ctx.formData.LightLogoPath
                            }, null, 8, _hoisted_11))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_drop_file, { onFileChange: _ctx.onLightLogoChange }, null, 8, ["onFileChange"])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[17] || (_cache[17] = _createElementVNode("h3", null, "Primary Color", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "color",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.PrimaryColor) = $event)),
                        style: {"margin-bottom":"0"}
                      }, null, 512), [
                        [_vModelText, _ctx.formData.PrimaryColor]
                      ])
                    ])
                  ]),
                  _createElementVNode("section", _hoisted_12, [
                    _createVNode(_component_chip_list_editor, {
                      modelValue: _ctx.formData.LocationsNew,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.LocationsNew) = $event)),
                      label: "Locations",
                      placeholder: "Add location..."
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("section", _hoisted_13, [
                    _createVNode(_component_chip_list_editor, {
                      modelValue: _ctx.formData.DepartmentsNew,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.DepartmentsNew) = $event)),
                      label: "Departments",
                      placeholder: "Add department..."
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("section", _hoisted_14, [
                    _createVNode(_component_chip_list_editor, {
                      modelValue: _ctx.formData.NodeTypesNew,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.NodeTypesNew) = $event)),
                      label: "Node Types",
                      placeholder: "Add node type..."
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : (_ctx.type == 'teamhub')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("section", _hoisted_16, [
                      _createVNode(_component_chip_list_editor, {
                        modelValue: _ctx.formData.EmployeeTeamsNew,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.EmployeeTeamsNew) = $event)),
                        label: "Employee Teams",
                        placeholder: "Add team..."
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("section", _hoisted_17, [
                      _createElementVNode("h3", null, [
                        _createElementVNode("a", {
                          onClick: _cache[8] || (_cache[8] = _withModifiers(() => { _ctx.showEmployeeFields = !_ctx.showEmployeeFields }, ["prevent"])),
                          style: {"text-decoration":"underline"}
                        }, "Employee Fields")
                      ]),
                      (_ctx.showEmployeeFields)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createVNode(_component_draggable, {
                              list: _ctx.formData.EmployeeFieldsNew
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.EmployeeFieldsNew, (field, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: i,
                                    class: "edit-form-field"
                                  }, [
                                    _createElementVNode("div", _hoisted_19, [
                                      (_openBlock(), _createElementBlock("svg", {
                                        onClick: ($event: any) => (_ctx.removeListItem(_ctx.formData.EmployeeFieldsNew, i)),
                                        fill: "red",
                                        style: {"width":"18px","height":"18px"},
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 24 24"
                                      }, [...(_cache[18] || (_cache[18] = [
                                        _createElementVNode("path", { d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.538l-4.592-4.548 4.546-4.587-1.416-1.403-4.545 4.589-4.588-4.543-1.405 1.405 4.593 4.552-4.547 4.592 1.405 1.405 4.555-4.596 4.591 4.55 1.403-1.416z" }, null, -1)
                                      ]))], 8, _hoisted_20))
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      placeholder: "Name",
                                      "onUpdate:modelValue": ($event: any) => ((field.name) = $event)
                                    }, null, 8, _hoisted_21), [
                                      [_vModelText, field.name]
                                    ]),
                                    _withDirectives(_createElementVNode("select", {
                                      "onUpdate:modelValue": ($event: any) => ((field.type) = $event)
                                    }, [...(_cache[19] || (_cache[19] = [
                                      _createElementVNode("option", { value: "text" }, "Text", -1),
                                      _createElementVNode("option", { value: "multitext" }, "Multi-Line Text", -1),
                                      _createElementVNode("option", { value: "date" }, "Date", -1),
                                      _createElementVNode("option", { value: "select" }, "Select", -1)
                                    ]))], 8, _hoisted_22), [
                                      [_vModelSelect, field.type]
                                    ]),
                                    (field.type == 'select')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                          _createVNode(_component_draggable, {
                                            list: field.options
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option, j) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: 'o'+j,
                                                  style: {"position":"relative"}
                                                }, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    style: {"padding":"5px 0","border":"0","margin":"0"},
                                                    type: "text",
                                                    "onUpdate:modelValue": ($event: any) => ((field.options[j]) = $event)
                                                  }, null, 8, _hoisted_24), [
                                                    [_vModelText, field.options[j]]
                                                  ]),
                                                  _createElementVNode("div", _hoisted_25, [
                                                    _createVNode(_component_svg_icon, {
                                                      onClick: ($event: any) => (_ctx.removeListItem(field.options, j)),
                                                      style: {"color":"red","width":"12px","height":"12px"},
                                                      icon: "x"
                                                    }, null, 8, ["onClick"])
                                                  ])
                                                ]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["list"]),
                                          _createElementVNode("form", {
                                            onSubmit: _withModifiers(($event: any) => (_ctx.addOption(field)), ["prevent"]),
                                            style: {"display":"flex","margin":"5px 0"}
                                          }, [
                                            _withDirectives(_createElementVNode("input", {
                                              style: {"flex":"1","margin-bottom":"0"},
                                              type: "text",
                                              "onUpdate:modelValue": ($event: any) => ((field.optionInput) = $event),
                                              placeholder: "Add Option"
                                            }, null, 8, _hoisted_27), [
                                              [_vModelText, field.optionInput]
                                            ]),
                                            _cache[20] || (_cache[20] = _createElementVNode("button", { class: "add-btn" }, "Add", -1))
                                          ], 40, _hoisted_26)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_28, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": ($event: any) => ((field.collectOnRegistration) = $event)
                                      }, null, 8, _hoisted_29), [
                                        [_vModelCheckbox, field.collectOnRegistration]
                                      ]),
                                      _cache[21] || (_cache[21] = _createElementVNode("div", null, "Collect on Registration", -1))
                                    ]),
                                    (field.collectOnRegistration)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "checkbox",
                                            "onUpdate:modelValue": ($event: any) => ((field.requiredOnRegistration) = $event)
                                          }, null, 8, _hoisted_31), [
                                            [_vModelCheckbox, field.requiredOnRegistration]
                                          ]),
                                          _cache[22] || (_cache[22] = _createElementVNode("div", null, "Required on Registration", -1))
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_32, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": ($event: any) => ((field.secure) = $event)
                                      }, null, 8, _hoisted_33), [
                                        [_vModelCheckbox, field.secure]
                                      ]),
                                      _cache[23] || (_cache[23] = _createElementVNode("div", null, "Secure Data", -1))
                                    ]),
                                    (field.type == 'date')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "checkbox",
                                            "onUpdate:modelValue": ($event: any) => ((field.celebrationDate) = $event)
                                          }, null, 8, _hoisted_35), [
                                            [_vModelCheckbox, field.celebrationDate]
                                          ]),
                                          _cache[24] || (_cache[24] = _createElementVNode("div", null, "Celebration Date", -1))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (field.type == 'date' && field.celebrationDate)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            placeholder: "Celebration Name",
                                            "onUpdate:modelValue": ($event: any) => ((field.celebrationName) = $event)
                                          }, null, 8, _hoisted_37), [
                                            [_vModelText, field.celebrationName]
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["list"]),
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("div", {
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addItem(_ctx.formData.EmployeeFieldsNew))),
                                class: "add-btn"
                              }, "Add Item")
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("section", _hoisted_39, [
                      _createElementVNode("h3", null, [
                        _createElementVNode("a", {
                          onClick: _cache[10] || (_cache[10] = _withModifiers(() => { _ctx.showEmployeeReviewFields = !_ctx.showEmployeeReviewFields }, ["prevent"])),
                          style: {"text-decoration":"underline"}
                        }, "Employee Review Fields")
                      ]),
                      (_ctx.showEmployeeReviewFields)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _createVNode(_component_draggable, {
                              list: _ctx.formData.EmployeeReviewFieldsNew
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.EmployeeReviewFieldsNew, (field, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: i,
                                    class: "edit-form-field"
                                  }, [
                                    _createElementVNode("div", _hoisted_41, [
                                      (_openBlock(), _createElementBlock("svg", {
                                        onClick: ($event: any) => (_ctx.removeListItem(_ctx.formData.EmployeeReviewFieldsNew, i)),
                                        fill: "red",
                                        style: {"width":"18px","height":"18px"},
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 24 24"
                                      }, [...(_cache[25] || (_cache[25] = [
                                        _createElementVNode("path", { d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.538l-4.592-4.548 4.546-4.587-1.416-1.403-4.545 4.589-4.588-4.543-1.405 1.405 4.593 4.552-4.547 4.592 1.405 1.405 4.555-4.596 4.591 4.55 1.403-1.416z" }, null, -1)
                                      ]))], 8, _hoisted_42))
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      placeholder: "Name",
                                      "onUpdate:modelValue": ($event: any) => ((field.name) = $event)
                                    }, null, 8, _hoisted_43), [
                                      [_vModelText, field.name]
                                    ]),
                                    _withDirectives(_createElementVNode("select", {
                                      "onUpdate:modelValue": ($event: any) => ((field.type) = $event)
                                    }, [...(_cache[26] || (_cache[26] = [
                                      _createElementVNode("option", { value: "text" }, "Text", -1),
                                      _createElementVNode("option", { value: "multitext" }, "Multi-Line Text", -1),
                                      _createElementVNode("option", { value: "date" }, "Date", -1),
                                      _createElementVNode("option", { value: "select" }, "Select", -1)
                                    ]))], 8, _hoisted_44), [
                                      [_vModelSelect, field.type]
                                    ]),
                                    (field.type == 'select')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                          _createVNode(_component_draggable, {
                                            list: field.options
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option, j) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: 'o'+j,
                                                  style: {"position":"relative"}
                                                }, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    style: {"padding":"5px 0","border":"0","margin":"0"},
                                                    type: "text",
                                                    "onUpdate:modelValue": ($event: any) => ((field.options[j]) = $event)
                                                  }, null, 8, _hoisted_46), [
                                                    [_vModelText, field.options[j]]
                                                  ]),
                                                  _createElementVNode("div", _hoisted_47, [
                                                    _createVNode(_component_svg_icon, {
                                                      onClick: ($event: any) => (_ctx.removeListItem(field.options, j)),
                                                      style: {"color":"red","width":"12px","height":"12px"},
                                                      icon: "x"
                                                    }, null, 8, ["onClick"])
                                                  ])
                                                ]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["list"]),
                                          _createElementVNode("form", {
                                            onSubmit: _withModifiers(($event: any) => (_ctx.addOption(field)), ["prevent"]),
                                            style: {"display":"flex","margin":"5px 0"}
                                          }, [
                                            _withDirectives(_createElementVNode("input", {
                                              style: {"flex":"1","margin-bottom":"0"},
                                              type: "text",
                                              "onUpdate:modelValue": ($event: any) => ((field.optionInput) = $event),
                                              placeholder: "Add Option"
                                            }, null, 8, _hoisted_49), [
                                              [_vModelText, field.optionInput]
                                            ]),
                                            _cache[27] || (_cache[27] = _createElementVNode("button", { class: "add-btn" }, "Add", -1))
                                          ], 40, _hoisted_48)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["list"]),
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("div", {
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addItem(_ctx.formData.EmployeeReviewFieldsNew))),
                                class: "add-btn"
                              }, "Add Item")
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("button", {
                type: "button",
                class: "btn-lg",
                disabled: _ctx.disableButton,
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.submit()))
              }, "Save Changes", 8, _hoisted_52)
            ])
          ])
        ]),
        _: 1
      }, 8, ["desc"])
    ], 2)
  ]))
}